export default __webpack_public_path__ + "static/media/Janod-gear-1.8e2e6a24.png";